<template lang="html">
<div class="pgment-6">
    <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="manageOrgName" label="机构名称">
        </el-table-column>
        <el-table-column prop="orgName" align="center" width="240" label="关联机构">
        </el-table-column>

        <el-table-column align="right" width="180">
            <template slot="header" slot-scope="scope">
                <el-button class="newAdd" type="primary" size="mini" @click="btnTrans('add')">新增</el-button>
            </template>
            <template slot-scope="scope">
                <el-button type="danger" @click="btnTrans('remove', scope.row)" size="mini">删除</el-button>
            </template>
        </el-table-column>
    </el-table>

    <div class="pg-figs">
        <el-pagination v-if="params.allPage > 1" layout="prev, pager, next" :current-page="params.no" @current-change="pageChange" :page-count="params.allPage">
        </el-pagination>
    </div>

    <el-dialog class="pgment6_pop" :visible.sync="diaCtls" width="600px" :before-close="handleClose">
        <div class="dialog-Body clearfix">
            <div class="bLeft">
                <div class="ttl">
                    自建机构
                </div>
                <div class="radioCage">
                    <el-scrollbar>
                        <el-radio-group v-model="ccParams.manageOrganizationId">
                            <div v-for="item in orgArr" class="radioItem">
                                <el-radio :label="item.id">{{ item.name }}</el-radio>
                            </div>
                        </el-radio-group>
                    </el-scrollbar>
                </div>
            </div>
            <div class="midCage">
                <i class="el-icon-aliziyuan"></i>
            </div>
            <div class="bRight">
                <div class="ttl">
                    供应机构
                </div>
                <div class="checkCage">
                    <el-scrollbar>
                        <el-checkbox-group v-model="ccParams.organizationId">
                            <div v-for="item in stationArr" class="checkItem">
                                <el-checkbox :label="item">{{ item.name }}</el-checkbox>
                            </div>
                        </el-checkbox-group>
                    </el-scrollbar>
                </div>
            </div>

        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="diaCtls = false">取 消</el-button>
            <el-button size="small" type="primary" @click="btnTrans('act')">确 定</el-button>
        </span>
    </el-dialog>

</div>
</template>

<script>
import {
    getConnected,
    getSites,
    goConnect,
    removeConnect
} from '@/api/pgMent/ccMent';
import {
    getMenu
} from '@/api/pgMent/sectMent';
export default {
    data() {
        return {
            params: {
                code: '',
                name: '',
                no: 1,
                size: 12,
                allPage: 0
            },

            props: {
                label: 'name',
                children: 'getCompanyPostModules'
            },

            diaCtls: false,
            tableData: [],

            //  机构
            orgArr: [],
            stationArr: [],
            diaInit: false,

            ccParams: {
                manageOrganizationId: '',
                organizationId: []
            }
        }
    },
    methods: {
        getListDat: function () {
            getConnected(this.params).then(response => {
                var codeMap = {
                    1: '中数老唱片',
                    3: '绝版赏析',
                    4: '戏曲',
                    5: '曲艺',
                    6: '丝绸之路'
                }
                this.tableData = response.orgManangeOrgListDTOList;
                this.params.allPage = response.totalPages;
                for (var i = 0; i < this.tableData.length; i++) {
                    this.tableData[i].orgName = this.tableData[i].orgName + ' - ' + codeMap[this.tableData[i].code];
                }
            })
        },
        btnTrans: function (code, dat) {
            if (code == 'add') {
                this.diaCtls = true;
                if (!this.diaInit) {
                    getMenu().then(response => {
                        this.orgArr = response.getCompanyPostTreeModules;
                    });
                    getSites().then(response => {
                        this.stationArr = response.orgManangeOrgDTOList
                        var codeMap = {
                            1: '中数老唱片',
                            3: '绝版赏析',
                            4: '戏曲',
                            5: '曲艺',
                            6: '丝绸之路'
                        }
                        for (var i = 0; i < this.stationArr.length; i++) {
                            this.stationArr[i].name = this.stationArr[i].name + ' - ' + codeMap[this.stationArr[i].code];
                        }

                    })
                    this.diaInit = true;
                }
            } else if (code == 'act') {
                var postDat = [];
                var transMap = {
                    1: 'LCP',
                    3: 'JBSX',
                    4: 'XQ',
                    5: 'QY',
                    6: 'SCZL'
                }
                for (var i = 0; i < this.ccParams.organizationId.length; i++) {
                    var temp = {
                        code: transMap[this.ccParams.organizationId[i].code],
                        manageOrganizationId: this.ccParams.manageOrganizationId,
                        organizationId: this.ccParams.organizationId[i].id
                    };
                    postDat.push(temp);
                }
                goConnect({
                    organizationManageOrganizationList: postDat
                }).then(response => {
                    this.$message.success('操作成功！');
                    this.diaCtls = false;

                    this.params.no = 1;
                    this.getListDat();
                })
            } else if (code == 'remove') {
                var vm = this;
                this.$confirm('确定要删除关联吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    removeConnect({
                        manageOrganizationIds: [dat.id]
                    }).then(response => {
                        vm.$message.success('删除成功！');

                        this.params.no = 1;
                        this.getListDat();
                    })
                }).catch(() => {});

            }
        },

        pageChange: function (inx) {
            this.params.no = inx;
            this.getListDat();
        }

    },
    created: function () {
        this.getListDat();
    }
}
</script>

<style lang="scss">
.pgment-6 {
    padding: 12px 20px;

    .newAdd {
        width: 90px;
        float: right;
    }

    .pg-figs {
        text-align: center;
        padding: 24px 0px;
    }
}

.pgment6_pop {
    .el-dialog__header {
        padding: 6px 0px;
    }

    .clearfix {
        *zoom: 1;
    }

    .clearfix:after {
        display: block;
        overflow: hidden;
        clear: both;
        height: 0;
        visibility: hidden;
        content: ".";
    }

    .dialog-Body {
        padding: 0px 12px;
    }

    .bLeft {
        width: 200px;
        float: left;

        .ttl {
            height: 36px;
            line-height: 36px;
            padding: 0px 12px;
            background: #f8f8f8;
        }

        .radioCage {
            padding: 0px 12px;
            border: 1px solid #f8f8f8;
            height: 200px;

            .el-scrollbar {
                height: 200px;

                .el-scrollbar__wrap {
                    padding-bottom: 9px;
                    padding-top: 9px;
                    overflow-x: hidden;
                }
            }
        }

        .radioItem {
            padding: 5px 0px;
        }
    }

    .midCage {
        float: left;
        width: 30px;
        text-align: center;
        margin-left: 34px;
        line-height: 240px;
        height: 200px;
        overflow: hidden;
    }

    .bRight {
        width: 240px;
        float: right;

        .ttl {
            height: 36px;
            line-height: 36px;
            padding: 0px 12px;
            background: #f8f8f8;
        }

        .checkCage {
            padding: 0px 12px;
            border: 1px solid #f8f8f8;
            height: 200px;

            .el-scrollbar {
                height: 200px;

                .el-scrollbar__wrap {
                    padding-bottom: 9px;
                    padding-top: 9px;
                    overflow-x: hidden;
                }
            }
        }

        .checkItem {
            padding: 5px 0px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// orgConnect.vue?78b285ca